import React, { ReactElement } from 'react';
import { useParams } from 'react-router';
import { NafCenterArticle } from '../pages/nafCenter/center';
import { NotFound } from '../loadable-elements/NotFound';

export const NafCenterPageRoute = (): ReactElement => {
  const { centerSlug } = useParams<{ centerSlug?: string }>();
  if (!centerSlug) {
    return <NotFound />;
  }
  return <NafCenterArticle centerSlug={centerSlug} />;
};
